module.exports = {
  color_input: {
    choose_color_button: 'Выбрать цвет',
  },
  edit_titles_text: {
    edit_icon: 'Переименовать',
  }
}
